import { render, staticRenderFns } from "./KeyboardBaseIngenico.vue?vue&type=template&id=56118a31&scoped=true"
import script from "./KeyboardBaseIngenico.vue?vue&type=script&lang=js"
export * from "./KeyboardBaseIngenico.vue?vue&type=script&lang=js"
import style0 from "./KeyboardBaseIngenico.vue?vue&type=style&index=0&id=56118a31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56118a31",
  null
  
)

export default component.exports